import { motion } from 'framer-motion';

import { Idle } from 'js/components';

export default function Page() {
  return (
    <main>
      <motion.div
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1 },
        }}
        initial="hidden"
        animate="visible"
        transition={{ duration: 0.5 }}
      >
        <Idle />
      </motion.div>
    </main>
  );
}
